import React from 'react';
import { Compass, ListChecks, SearchCheck } from 'lucide-react';
import './AboutPage.css';

function AboutPage() {
  return (
    <main className="about-page">
      <div className="about-page__inner">
        <header className="about-page__header">
          <span className="about-page__eyebrow">About MaiColleges</span>
          <h1>College planning should not feel impossible.</h1>
          <p>
            MaiColleges began as a senior project created by a high school student who felt overwhelmed
            by the college search and application process.
          </p>
        </header>

        <section className="about-page__story" aria-label="MaiColleges story">
          <p>
            College planning involved too many moving pieces: researching schools, comparing programs
            and costs, tracking essays, remembering deadlines, checking application portals, and figuring
            out what to do next. Information was spread across websites, spreadsheets, notes, and
            conversations, with no clear place to bring it all together.
          </p>
          <p>MaiColleges was built to change that.</p>
          <p>
            We believe students do not procrastinate because they do not care. They procrastinate because
            the college process is ambiguous, high-stakes, and full of small, easy-to-miss steps. When
            everything feels important, it can be hard to know where to begin.
          </p>
          <p>
            MaiColleges turns that overwhelm into a guided workspace. Students can search for colleges,
            create an auto-filled dashboard with trusted school information, compare their options,
            organize their list, track applications and deadlines, and see the next steps that need
            their attention.
          </p>
          <p>
            Instead of starting with a blank spreadsheet or an overwhelming checklist, students can begin
            with a few simple actions: add schools, explore their options, move schools into progress,
            and keep track of what comes next.
          </p>
        </section>

        <section className="about-page__principles" aria-label="What MaiColleges helps students do">
          <article>
            <div className="about-page__icon"><SearchCheck size={20} strokeWidth={1.8} /></div>
            <h2>Start with real information</h2>
            <p>Search for colleges and build dashboards with trusted school data already filled in.</p>
          </article>
          <article>
            <div className="about-page__icon"><Compass size={20} strokeWidth={1.8} /></div>
            <h2>Know the next step</h2>
            <p>Turn a scattered process into smaller actions that are easier to start and return to.</p>
          </article>
          <article>
            <div className="about-page__icon"><ListChecks size={20} strokeWidth={1.8} /></div>
            <h2>Stay organized over time</h2>
            <p>Track research, applications, deadlines, essays, and progress in one guided workspace.</p>
          </article>
        </section>

        <section className="about-page__goal" aria-label="MaiColleges goal">
          <h2>Our goal</h2>
          <p>
            Make the college search and application process feel clearer, more organized, and more
            manageable, so students can spend less time trying to keep up and more time making confident
            decisions about their future.
          </p>
        </section>
      </div>
    </main>
  );
}

export default AboutPage;
